// src/pages/Documents.tsx
import React from "react";
import { PageHeader } from "../components/PageHeader.tsx";
import { TAB_DESCRIPTIONS } from "../constants/tabDescriptions.ts";
import "./Documents.css";

export const Documents: React.FC = () => {
  const pdfFileName = "Expanded Chess Manual.pdf";
  const pdfPath = "/documents/Expanded Chess Manual.pdf";

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = pdfPath;
    link.download = pdfFileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="documents-page">
      <PageHeader
        icon={TAB_DESCRIPTIONS.documents.icon}
        title={TAB_DESCRIPTIONS.documents.label}
        description={TAB_DESCRIPTIONS.documents.description}
      />

      <div className="documents-content">
        {/* Document Card */}
        <div className="document-card">
          {/* Document Info Header */}
          <div className="document-header">
            <div className="document-info">
              <span className="document-icon">📕</span>
              <div>
                <h2 className="document-title">Expanded Chess Manual</h2>
                <p className="document-subtitle">
                  Complete game rules and piece descriptions
                </p>
              </div>
            </div>
            <button onClick={handleDownload} className="download-btn">
              <span>⬇️</span>
              <span>Download PDF</span>
            </button>
          </div>

          {/* PDF Viewer */}
          <div className="pdf-viewer">
            <iframe
              src={pdfPath}
              title="Expanded Chess Rules PDF"
              className="pdf-iframe"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Documents;
